<template>
  <div class="address-edit" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="editAddress && !isWechatBrowser" title="编辑地址" :showBack="true"></my-header>
    <my-header v-if="!editAddress && !isWechatBrowser" title="添加新地址" :showBack="true"></my-header>
    <!-- <div class="address-frame general-box-shadow"> -->
    <div class="address-frame">
      <div class="address-edit-form-item border-bottom-style">
        <div class="form-title">姓名</div>
        <input class="form-input" type="text" v-model="receiver" placeholder="请输入姓名"/>
      </div>
      <div class="address-edit-form-item border-bottom-style">
        <div class="form-title">手机号</div>
        <input class="form-input" type="number" v-model="phone" placeholder="请输入手机号"/>
      </div>
      <div class="address-edit-form-item border-bottom-style">
        <div class="form-city">
          <div class="form-title">省份城市</div>
          <!-- <img class="city" src="../../assets/icon-supervisor-sort-down.png"> -->
        </div>
        <input class="form-input" type="" v-model="city" readonly placeholder="请选择省份城市县市区"/>
      </div>
      <div class="address-edit-form-item border-bottom-style" >
        <div class="form-title">详细地址</div>
        <input class="form-input" type="text" v-model="address" placeholder="请输入详细地址"/>
      </div>
      <div @click="installDefault()" class="operate-part">
        <span><img v-if="!isDefaulted" class="card-operation icon-set-default" src="../../assets/icon/icon-check-box-unselect.png">
        <img v-if="isDefaulted" class="card-operation icon-set-default" src="../../assets/icon/icon-check-box-selected.png"></span>
        <span class="operation-text" :class="{'address-defaulted-color':isDefaulted}">{{operationText}}</span>
        <div v-if="editAddress && !isWechatBrowser" class="delete-btn" @click="">删除</div>
      </div>
    </div>
    <div class="bank-card-save-btn" @click="saveAddress">{{btnText}}</div>
  </div>
</template>
<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import Select from '../../components/select/Select'
  import customerAddressService from '../../service/customer/CustomerAddressService'

  export default{
    name: 'AddressEdit',
    components: {
      'my-header': Header,
      'my-select': Select,
    },
    data () {
      return {
        addressId:'',
        receiver:'',
        phone:'',
        address:'',
        editAddress:'',
        city: '北京市',
        btnText:'确定',
        isDefaulted:false,
        isDefault:'0',
        operationText:'默认',
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    created(){
      this.addressId = this.$route.query.addressId || '';
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      if(this.addressId){
        this.addressDetail();
      }
    },
    methods: {
      async addressDetail(){
        let result = await customerAddressService.detail(this.addressId);
        if(result.code == '0'){
          this.editAddress = result.data;
          if(this.editAddress){
            document.title = '编辑地址';
            this.btnText = '保存';
            this.receiver = this.editAddress.receiver;
            this.phone = this.editAddress.phone;
            this.address = this.editAddress.address;
            this.isDefault = this.editAddress.isDefault;
            if(this.isDefault == '1'){
              this.isDefaulted = true;
              this.operationText = '默认';
            }else {
              this.isDefaulted = false;
              this.operationText = '默认';
            }
          }
        }else {
          Toast(result.msg);
        }
      },
      installDefault(){
        this.isDefaulted = !this.isDefaulted;
        if(this.isDefaulted){
          this.isDefault = '1';
          this.operationText = '默认';
        }else {
          this.isDefault = '0';
          this.operationText = '默认';
        }
      },
      async saveAddress(){
        if(!this.receiver){
          Toast('请输入联系人');
          return ;
        }
        if(this.phone){
          var re= /^1[34578]\d{9}$/;
          if(!re.test(this.phone)){
            Toast('您的联系电话格式不正确');
            return ;
          }
        }else {
          Toast('请输入您的联系电话');
          return ;
        }
        if(!this.address){
          Toast('请输入收货地址');
          return ;
        }
        let customerAddress = {id:this.addressId,receiver:this.receiver,isDefault:this.isDefault,phone:this.phone,address:this.address};
        let result = await customerAddressService.save(customerAddress);
        if(result.code == '0'){
          Toast('地址信息保存成功！');
          if(this.global.isMiniProgrm){
            wx.miniProgram.navigateBack()
          }else{
            this.$router.go(-1);
          }
        }else {
          Toast(result.msg);
        }
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .address-edit {
    height: 100vh;
    padding-top: 0.4rem;
    background-color: white;
    font-size: 0.32rem;
     .address-frame {
       width: 6.9rem;
       margin: 0 auto;
     }
     .address-edit-form-item{
       width: 6.29rem;
       margin: 0 auto;
       padding-bottom: 0.2rem;
       .form-city{
         display: flex;
         justify-content: space-between;
       }
       .form-title{
         padding-top: 0.3rem;
         margin-bottom: 0.15rem;
         font-size: 0.28rem;
         color: #7f7d7c;
       }
       .city{
         box-sizing: border-box;
         margin-top: 0.2rem;
         width: 0.2rem;
         height: 0.2rem;
       }
       .form-input{
         width: 5rem;
         line-height: 0.3rem;
         font-size: 0.32rem;
         color: #191818;
       }
     }
     .operate-part{
       position: absolute;
       right: 0.3rem;
       padding-left: 0.3rem;
       height: 1.33rem;
       line-height: 1.2rem;
       display: flex;
       .delete-btn{
         width: 0.8rem;
         height: 0.4rem;
         margin-top: 0.4rem;
         margin-right: 0.3rem;
         font-size: 0.24rem;
         color: #ffffff;
         line-height: 0.4rem;
         text-align: center;
         border-radius: 20px;
         background-color: #d54a33;
       }
     }
     .icon-set-default{
       width: 0.37rem;
       height: 0.37rem;
       margin: 0.37rem 0.1rem 0.6rem 0;
       margin-top: 0.45rem;
     }
     .operation-text{
       margin-left: 0.1rem;
       flex-grow: 1;
     }
     .address-defaulted-color{
       color: #191818;
     }
     .bank-card-save-btn {
      position: fixed;
      bottom: 0.5rem;
      left:0;
      right:0;
      margin: 0 auto;
      width: 90%;
      height: 0.8rem;
      border-radius: 0.1rem;
      // margin: 6.5rem 0.3rem 0 0.3rem;
      text-align: center;
      background-color: rgb(0,71,142);
      font-size: 0.36rem;
      color: white;
      line-height: 0.85rem;
      letter-spacing: 0.05rem;
     }
  }
</style>
